import Config from "./vueconfig.js";
/**
 * environment
 * @function getAppId
 * @function getAppName
 * @function getApiUrl
 * @function getApiModuleUrl
 * @function getBlobUrl
 * @function getMiscUrl
 * @function getShoppingCartUrl
 * api config str
 * @function getCampaignConfig
 * @function getDashboardConfig
 * @function getCategoryConfig
 * @function getHistoryConfig
 * setting
 * @function getCacheType
 * custom
 * @function getCampaignListDevApp
 * @function getCategoryMenuDev
 */
export default {

    //#region normal environment
    getAppId: function () {
        return Config().client_id;
    },
    getAppName: function () {
        return Config().appname;
    },
    getApiUrl: function () {
        return Config().bzbsUrl;
    },
    getApiModuleUrl: function () {
        return Config().bzbsModuleUrl;
    },
    getBlobUrl: function () {
        return Config().bzbsBlobUrl;
    },
    getMiscUrl: function () {
        return Config().miscUrl;
    },
    getShoppingCartUrl: function () {
        return Config().bzbsShoppingCartUrl;
    },
    getApiShoppingCartUrl: function () {
        return Config().apiShoppingCartUrl;
    },
    getApi: function () {
        return Config().api;
    },
    //#endregion normal environment

    //#region config str
    /**
     *
     * @returns {import("@/types/Config.d").CampaignConfig}
     */
    getCampaignConfig: function () {
        return Config().campaignConfig;
    },
    /**
     *
     * @returns {import("@/types/Config.d").DashboardConfig}
     */
    getDashboardConfig: function () {
        return Config().dashboardConfig;
    },
    /**
     *
     * @returns {import("@/types/Config.d").CategoryConfig}
     */
    getCategoryConfig: function () {
        return Config().categoryConfig;
    },
    /**
     *
     * @returns {import("@/types/Config.d").HistoryConfig}
     */
    getHistoryConfig: function () {
        return Config().historyConfig;
    },
    //#endregion config str

    //#region setting
    getCacheType: function () {
        return Config().setting.cache;
    },
    getAddressType: function () {
        return Config().setting.addressType;
    },
    getFirebaseSetup: function () {
        return Config().firebase;
    },
    getEncryptSetting: function () {
        return Config().setting.encryptAccount;
    },
    //#endregion setting

    //#region custom
    // dashboard
    getDashboardHotPromotionConfig: function () {
        return this.getDashboardConfig().dashboardHotPromotion
    },
    getDashboardSearchPromotionConfig: function () {
        return this.getDashboardConfig().searchPromotion
    },
    getDashboardSearchPromotionSubCategoryConfig: function () {
        return this.getDashboardConfig().searchPromotionSubCategory
    },
    getDashboardApplyCard: function () {
        return this.getDashboardConfig().applyCard
    },
    getDashboardRegistered: function () {
        return this.getDashboardConfig().registered
    },
    getDashboardCardPrivilege: function () { //jcb_card_privilege
        return this.getDashboardConfig().jcbCardPrivilege
    },
    getDashboardUltimateService: function(){ //jcb_ultimate_service
        return this.getDashboardConfig().jcbUltimaterService
    },
    getDashboardSpecialForYou: function () {
        return this.getDashboardConfig().jcbSpecialForYou
    },
    // campaign
    getCampaignHotPromotion: function () {
        return this.getCampaignConfig().campaignHotPromotion;
    },
    getCampaignSpecialForYou: function () {
        return this.getCampaignConfig().campaignSpecialForYou;
    },
    getCampaignListDevApp: function () {
        return this.getCampaignConfig().campaignListConfig;
    },
    getCampaignPlatinumService: function () {
        return this.getCampaignConfig().campaignPlatinumListConfig;
    },
    getCampaignUltimateService: function () {
        return this.getCampaignConfig().campaignUltimateService
    },
    // category
    getCategoryMenuDev: function () {
        return this.getCategoryConfig().menuCategory;
    },
    getCategoryPlatinumService: function () {
        return this.getCategoryConfig().platinumService
    },
    getCategorySpecialForYou: function () {
        return this.getCategoryConfig().special4you
    },
    getCategoryUltimateService: function () {
        return this.getCategoryConfig().ultimateService
    },
    // history
    getHistoryPurchaseList: function () {
        return this.getHistoryConfig().purchase;
    },
    getHistPurchaseUnused: function(){
        return this.getHistoryConfig().purchaseUnused;
    }
    //#endregion custom
}
